import { FaWhatsapp } from "react-icons/fa";
import "./WhatsAppButton.css";

export default function WhatsAppButton(props) {
  return (
    <a
      href={`https://wa.me/${props.whatsAppNumber}?text=Gostaria%20de%20saber%20mais%20sobre%20a%20Vida%20Premiada%20Krause.`}
      rel="noopener noreferrer"
      className="whats-app-btn-link"
      target="_blank"
      aria-label="Entre em contato via WhatsApp"
    >
      <div className="whats-app-floating-btn-container">
        <p>
          FAÇA SEU PLANO <br />E CONCORRA
        </p>
        <div id="whats-app-floating-btn">
          <FaWhatsapp className="whats-app-btn-icon" />
        </div>
      </div>
    </a>
  );
}
